(function() {
  'use strict';

  var checkoutSelector = 'button[name="checkout"]';

  function enableCheckout(button) {
    if (!button) {
      return;
    }

    if (button.disabled || button.hasAttribute('disabled')) {
      button.disabled = false;
      button.removeAttribute('disabled');
    }

    if (button.classList.contains('isDisabled')) {
      button.classList.remove('isDisabled');
    }

    if (button.getAttribute('aria-disabled') !== 'false') {
      button.setAttribute('aria-disabled', 'false');
    }
  }

  function watchCheckout(button) {
    if (!button || button.hasAttribute('data-checkout-guarded')) {
      return;
    }

    button.setAttribute('data-checkout-guarded', 'true');
    enableCheckout(button);

    var buttonObserver = new MutationObserver(function() {
      enableCheckout(button);
    });

    buttonObserver.observe(button, {
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled']
    });
  }

  function findCheckoutButtons(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) {
      return;
    }

    if (root.nodeName === 'BUTTON' && root.getAttribute('name') === 'checkout') {
      watchCheckout(root);
    }

    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(checkoutSelector), watchCheckout);
    }
  }

  function refreshCheckoutButtons() {
    findCheckoutButtons(document);
  }

  refreshCheckoutButtons();
  document.addEventListener('theme:cart:change', refreshCheckoutButtons);
  document.addEventListener('theme:cart:reload', refreshCheckoutButtons);

  function watchCartContainer(container) {
    if (container.hasAttribute('data-checkout-container-guarded')) {
      return;
    }

    container.setAttribute('data-checkout-container-guarded', 'true');
    findCheckoutButtons(container);

    // Cart sections can be updated with AJAX. Inspect only additions inside
    // those sections so unrelated app DOM changes never trigger cart scans.
    var cartObserver = new MutationObserver(function(mutations) {
      Array.prototype.forEach.call(mutations, function(mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, findCheckoutButtons);
      });
    });

    cartObserver.observe(container, { childList: true, subtree: true });
  }

  function watchCartContainers(root) {
    var cartContainerSelector = '[data-section-type="cart"], [data-section-type="cart-drawer"]';

    if (root.nodeType === 1) {
      var sectionType = root.getAttribute('data-section-type');
      if (sectionType === 'cart' || sectionType === 'cart-drawer') {
        watchCartContainer(root);
      }
    }

    Array.prototype.forEach.call(root.querySelectorAll(cartContainerSelector), watchCartContainer);
  }

  watchCartContainers(document);
  document.addEventListener('shopify:section:load', function(event) {
    watchCartContainers(event.target);
  });

  function isHistoryNavigation(event) {
    if (event.persisted) {
      return true;
    }

    if (!window.performance) {
      return false;
    }

    if (typeof window.performance.getEntriesByType === 'function') {
      var navigationEntries = window.performance.getEntriesByType('navigation');
      if (navigationEntries.length && navigationEntries[0].type === 'back_forward') {
        return true;
      }
    }

    return window.performance.navigation &&
      window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD;
  }

  function refreshCartAfterHistoryNavigation(event) {
    if (!isHistoryNavigation(event)) {
      return;
    }

    function refreshCart() {
      window.fetch(window.theme.routes.cart + '.js')
        .then(function(response) {
          if (!response.ok) {
            throw new Error(response.statusText);
          }
          return response.json();
        })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          }));
        })
        .catch(function(error) {
          console.error(error);
        });
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(refreshCart, { timeout: 500 });
    } else {
      refreshCart();
    }
  }

  window.addEventListener('pageshow', refreshCartAfterHistoryNavigation);

  var photoSwipePromise;

  function loadPhotoSwipe() {
    if (window.themePhotoswipe) {
      return Promise.resolve();
    }

    if (!photoSwipePromise) {
      photoSwipePromise = new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.src = window.theme.assets.photoswipe;
        script.onload = function() {
          if (window.themePhotoswipe) {
            resolve();
          } else {
            photoSwipePromise = null;
            reject(new Error('PhotoSwipe loaded without initializing.'));
          }
        };
        script.onerror = function() {
          photoSwipePromise = null;
          reject(new Error('PhotoSwipe failed to load.'));
        };
        document.head.appendChild(script);
      });
    }

    return photoSwipePromise;
  }

  function openProductZoom(trigger) {
    var container = trigger.closest('[data-section-type="product"]');
    var zoomWrapper = container && container.querySelector('[data-zoom-wrapper]');
    var productJson = container && container.querySelector('[data-product-json]');
    var mediaSlide = trigger.closest('[data-media-id]');

    if (!container || !zoomWrapper || !productJson || !mediaSlide) {
      throw new Error('Product zoom markup is incomplete.');
    }

    var product = JSON.parse(productJson.textContent);
    var mediaId = mediaSlide.getAttribute('data-media-id');
    var items = product.media
      .filter(function(media) {
        return media.media_type === 'image';
      })
      .map(function(media) {
        return {
          src: media.src,
          w: media.width,
          h: media.height,
          id: media.id
        };
      });
    var selectedIndex = -1;
    items.some(function(item, index) {
      if (item.id.toString() === mediaId.toString()) {
        selectedIndex = index;
        return true;
      }
      return false;
    });
    var PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
    var PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
    var options = {
      index: selectedIndex,
      showHideOpacity: true,
      showAnimationDuration: 150,
      hideAnimationDuration: 250,
      bgOpacity: 1,
      spacing: 0,
      allowPanToNext: false,
      maxSpreadZoom: 3,
      history: false,
      loop: true,
      pinchToClose: false,
      modal: false,
      closeOnScroll: false,
      closeOnVerticalDrag: true,
      getDoubleTapZoom: function(isMouseClick, item) {
        if (isMouseClick) {
          return 1.67;
        }
        return item.initialZoomLevel < 0.7 ? 1 : 1.3;
      },
      getThumbBoundsFn: function() {
        var imageLocation = container.querySelector('[data-product-slideshow]') ||
          container.querySelector('[data-product-image]');
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        var rect = imageLocation.getBoundingClientRect();

        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width
        };
      }
    };

    zoomWrapper.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));

    var gallery = new PhotoSwipe(zoomWrapper, PhotoSwipeUI, items, options);
    gallery.init();
    gallery.listen('close', function() {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    });
  }

  // Product carousels clone slides after initialization. Event delegation keeps
  // zoom working on those clones because cloned DOM nodes do not retain direct
  // event listeners.
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest && event.target.closest('[data-deferred-zoom-button]');
    if (!trigger) {
      return;
    }

    event.preventDefault();

    if (trigger.getAttribute('aria-busy') === 'true') {
      return;
    }

    trigger.setAttribute('aria-busy', 'true');
    loadPhotoSwipe()
      .then(function() {
        openProductZoom(trigger);
      })
      .catch(function(error) {
        console.error(error);
      })
      .then(function() {
        trigger.removeAttribute('aria-busy');
      });
  });

  function hydrateDeferredProductImage(image) {
    if (!image || !image.hasAttribute('data-deferred-product-image')) {
      return;
    }

    var srcset = image.getAttribute('data-deferred-srcset');
    var src = image.getAttribute('data-deferred-src');

    if (srcset) {
      image.setAttribute('srcset', srcset);
    }
    if (src) {
      image.setAttribute('src', src);
    }

    image.removeAttribute('data-deferred-product-image');
    image.removeAttribute('data-deferred-src');
    image.removeAttribute('data-deferred-srcset');
  }

  function hydrateDeferredNavigationImage(image) {
    if (!image || !image.hasAttribute('data-deferred-navigation-image')) {
      return;
    }

    var srcset = image.getAttribute('data-deferred-srcset');
    var src = image.getAttribute('data-deferred-src');

    if (srcset) {
      image.setAttribute('srcset', srcset);
    }
    if (src) {
      image.setAttribute('src', src);
    }

    image.removeAttribute('data-deferred-navigation-image');
    image.removeAttribute('data-deferred-src');
    image.removeAttribute('data-deferred-srcset');
  }

  function hydrateNavigationDisclosure(trigger) {
    if (!trigger) {
      return;
    }

    var disclosureId = trigger.getAttribute('aria-controls');
    var disclosure = disclosureId && document.getElementById(disclosureId);
    if (!disclosure) {
      return;
    }

    Array.prototype.forEach.call(
      disclosure.querySelectorAll('[data-deferred-navigation-image]'),
      hydrateDeferredNavigationImage
    );
  }

  function navigationDisclosureTrigger(event) {
    var trigger = event.target.closest && event.target.closest('[data-hover-disclosure-toggle]');
    hydrateNavigationDisclosure(trigger);
  }

  document.addEventListener('pointerover', navigationDisclosureTrigger, { passive: true });
  document.addEventListener('focusin', navigationDisclosureTrigger);
  document.addEventListener('touchstart', navigationDisclosureTrigger, { passive: true });

  function hydrateProductMediaSlide(slide) {
    if (!slide) {
      return;
    }

    Array.prototype.forEach.call(
      slide.querySelectorAll('[data-deferred-product-image]'),
      function(image) {
        hydrateDeferredProductImage(image);

        // Promote the selected image so native lazy loading cannot leave the
        // newly visible hero stalled with an empty currentSrc.
        image.setAttribute('loading', 'eager');
        image.setAttribute('fetchpriority', 'high');
      }
    );
  }

  function findProductMediaSlide(gallery, mediaId) {
    var slides = gallery.querySelectorAll('[data-media-slide]');
    var id = mediaId === null || typeof mediaId === 'undefined' ? '' : mediaId.toString();

    for (var index = 0; index < slides.length; index += 1) {
      if (slides[index].getAttribute('data-media-id') === id) {
        return slides[index];
      }
    }

    return null;
  }

  function hydrateDeferredProductThumbnail(image) {
    if (!image || !image.hasAttribute('data-deferred-product-thumbnail')) {
      return;
    }

    var src = image.getAttribute('data-deferred-thumbnail-src');
    var clearLoadingState = function() {
      image.classList.remove('loading-shimmer');
    };

    image.addEventListener('load', clearLoadingState, { once: true });

    if (src) {
      image.setAttribute('src', src);
    }

    image.removeAttribute('data-deferred-product-thumbnail');
    image.removeAttribute('data-deferred-thumbnail-src');

    if (image.complete && image.naturalWidth > 1) {
      clearLoadingState();
    }
  }

  var deferredProductThumbnailObserver = 'IntersectionObserver' in window ?
    new IntersectionObserver(function(entries) {
      Array.prototype.forEach.call(entries, function(entry) {
        if (!entry.isIntersecting) {
          return;
        }

        deferredProductThumbnailObserver.unobserve(entry.target);
        hydrateDeferredProductThumbnail(entry.target);
      });
    }, { rootMargin: '250px' }) : null;

  function watchDeferredProductThumbnail(image) {
    if (deferredProductThumbnailObserver) {
      deferredProductThumbnailObserver.observe(image);
    } else {
      hydrateDeferredProductThumbnail(image);
    }
  }

  function findDeferredProductThumbnails(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (root.matches && root.matches('[data-deferred-product-thumbnail]')) {
      watchDeferredProductThumbnail(root);
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-deferred-product-thumbnail]'),
      watchDeferredProductThumbnail
    );
  }

  var deferredProductMediaGalleries = new WeakSet();
  var deferredProductMediaSections = new WeakSet();

  function watchDeferredProductMedia(gallery) {
    if (deferredProductMediaGalleries.has(gallery)) {
      return;
    }

    deferredProductMediaGalleries.add(gallery);
    gallery.removeAttribute('data-deferred-media-watched');

    hydrateProductMediaSlide(
      gallery.querySelector('[data-media-slide].is-selected') ||
      gallery.querySelector('[data-media-slide]')
    );

    gallery.addEventListener('theme:image:change', function(event) {
      if (!event.detail) {
        return;
      }

      hydrateProductMediaSlide(findProductMediaSlide(gallery, event.detail.id));
    });

    var selectedSlideObserver = new MutationObserver(function() {
      hydrateProductMediaSlide(gallery.querySelector('[data-media-slide].is-selected'));
    });

    selectedSlideObserver.observe(gallery, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }

  function findDeferredProductMedia(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (root.matches && root.matches('[data-product-slideshow]')) {
      watchDeferredProductMedia(root);
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-product-slideshow]'),
      watchDeferredProductMedia
    );
  }

  function watchDeferredProductMediaSection(section) {
    if (deferredProductMediaSections.has(section)) {
      return;
    }

    deferredProductMediaSections.add(section);
    section.removeAttribute('data-deferred-media-section-watched');
    findDeferredProductMedia(section);
    findDeferredProductThumbnails(section);
  }

  function refreshDeferredProductMedia(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (root.matches && root.matches('[data-section-type="product"]')) {
      watchDeferredProductMediaSection(root);
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-section-type="product"]'),
      watchDeferredProductMediaSection
    );
  }

  var stickyAddToCartSections = new WeakSet();

  function watchStickyAddToCart(section) {
    if (
      !section ||
      stickyAddToCartSections.has(section) ||
      section.closest('[data-quickview-modal]')
    ) {
      return;
    }

    var buttons = section.querySelector('[data-sticky-add-to-cart]');
    var sentinel = section.querySelector('[data-sticky-add-to-cart-sentinel]');
    var wrapper = buttons && buttons.closest('[data-buttons-wrapper]');
    if (!buttons || !sentinel || !wrapper) {
      return;
    }

    stickyAddToCartSections.add(section);

    var mobileQuery = window.matchMedia('(max-width: 767px)');
    var hasPassedButton = false;
    var isSticky = false;

    function setStickyAddToCart(active) {
      if (active === isSticky) {
        return;
      }

      isSticky = active;

      if (active) {
        wrapper.style.setProperty(
          '--sticky-add-to-cart-placeholder-height',
          buttons.getBoundingClientRect().height + 'px'
        );
      } else {
        wrapper.style.removeProperty('--sticky-add-to-cart-placeholder-height');
      }

      wrapper.classList.toggle('has-sticky-add-to-cart', active);
      buttons.classList.toggle('is-sticky-add-to-cart', active);
    }

    function syncStickyAddToCart() {
      setStickyAddToCart(mobileQuery.matches && hasPassedButton);
    }

    if ('IntersectionObserver' in window) {
      var sentinelObserver = new IntersectionObserver(function(entries) {
        Array.prototype.forEach.call(entries, function(entry) {
          hasPassedButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          syncStickyAddToCart();
        });
      });

      sentinelObserver.observe(sentinel);
    } else {
      var checkStickyAddToCart = function() {
        hasPassedButton = sentinel.getBoundingClientRect().bottom < 0;
        syncStickyAddToCart();
      };

      window.addEventListener('scroll', checkStickyAddToCart, { passive: true });
      checkStickyAddToCart();
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncStickyAddToCart);
    } else {
      mobileQuery.addListener(syncStickyAddToCart);
    }
  }

  function refreshStickyAddToCart(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (root.matches && root.matches('[data-section-type="product"]')) {
      watchStickyAddToCart(root);
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-section-type="product"]'),
      watchStickyAddToCart
    );
  }

  refreshDeferredProductMedia(document);
  refreshStickyAddToCart(document);
  document.addEventListener('shopify:section:load', function(event) {
    refreshDeferredProductMedia(event.target);
    refreshStickyAddToCart(event.target);
  });

  function findGridVariantPanel(gridItem, variantId) {
    var panels = gridItem.querySelectorAll('product-grid-item-variant[data-grid-item-variant]');

    for (var index = 0; index < panels.length; index += 1) {
      if (panels[index].getAttribute('data-grid-item-variant') === variantId) {
        return panels[index];
      }
    }

    return null;
  }

  function hydrateSelectedGridVariant(panel) {
    if (!panel) {
      return;
    }

    var targetImage = panel.querySelector('[data-slide-for-variant-media]') ||
      panel.querySelector('[data-grid-image]');

    if (!targetImage) {
      return;
    }

    Array.prototype.forEach.call(
      panel.querySelectorAll('[data-grid-image][data-grid-current-image]'),
      function(image) {
        if (image !== targetImage) {
          image.removeAttribute('data-grid-current-image');
        }
      }
    );

    // ProductGridItemImage expands its template when loading becomes eager.
    // Hydrate only the chosen color/sibling instead of every hidden panel.
    targetImage.setAttribute('loading', 'eager');
    targetImage.setAttribute('data-grid-current-image', 'true');
  }

  // Run before Pipeline's direct swatch click handler. This keeps touch and
  // keyboard selection working when hidden card images are template-wrapped.
  document.addEventListener('click', function(event) {
    var swatchLink = event.target.closest &&
      event.target.closest('product-grid-item a[data-grid-item-variant]');

    if (!swatchLink) {
      return;
    }

    var gridItem = swatchLink.closest('product-grid-item');
    var variantId = swatchLink.getAttribute('data-grid-item-variant');

    hydrateSelectedGridVariant(findGridVariantPanel(gridItem, variantId));
  }, true);

  // Some products use variant featured-image positions as gallery boundaries
  // instead of #group_variant alt-text tags. Prepare Pipeline's native image
  // filter during the capture phase so its existing listener can hide cells and
  // reload both Flickity sliders in the same variant-change event.
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail && event.detail.variant;
    var featuredMedia = variant && (variant.featured_media || variant.featured_image);
    var groupPosition = featuredMedia && featuredMedia.position;

    if (!groupPosition || !event.target.closest) {
      return;
    }

    var productSection = event.target.closest('[data-section-type="product"]');
    var gallery = productSection && productSection.querySelector('[data-product-gallery-order-groups]');

    if (!gallery) {
      return;
    }

    var groupValue = String(groupPosition);
    var groupedMedia = productSection.querySelectorAll('[data-variant-media-group]');
    var visibleSlideCount = 0;

    Array.prototype.forEach.call(groupedMedia, function(mediaItem) {
      var mediaGroup = mediaItem.getAttribute('data-variant-media-group');
      var shouldShow = mediaGroup === '0' || mediaGroup === groupValue;

      if (shouldShow && mediaItem.hasAttribute('data-media-slide')) {
        visibleSlideCount += 1;
      }

      mediaItem.setAttribute(
        'data-image-filter',
        shouldShow ? '' : '__order_group_hidden__'
      );
    });

    gallery.classList.toggle(
      'product__grid--single-visible-media',
      visibleSlideCount === 1
    );

    // Pipeline resets every gallery cell when a variant image has no alt
    // text. Supply a temporary group token so its listener takes the normal
    // filtering path and reloads Flickity with only this color's cells.
    var variantImage = variant.featured_image;
    if (variantImage && variantImage.alt == null) {
      var originalAlt = variantImage.alt;
      var temporaryAlt = '#__order_group__';
      variantImage.alt = temporaryAlt;

      window.setTimeout(function() {
        if (variantImage.alt === temporaryAlt) {
          variantImage.alt = originalAlt;
        }
      }, 0);
    }
  }, true);

  var customWishlistButton = document.getElementById('custom-wishlist-button');
  if (!customWishlistButton) {
    return;
  }

  function bindWishlistButton() {
    var appWishlistButton = document.querySelector('.iwish-float-icon');
    if (!appWishlistButton) {
      return false;
    }

    customWishlistButton.addEventListener('click', function() {
      var currentAppWishlistButton = document.querySelector('.iwish-float-icon');
      if (currentAppWishlistButton) {
        currentAppWishlistButton.click();
      }
    });

    return true;
  }

  if (bindWishlistButton()) {
    return;
  }

  // iWish injects its button asynchronously. Stop observing as soon as it is
  // available, and resolve the current app button only when the shopper clicks.
  var wishlistObserver = new MutationObserver(function(mutations, observer) {
    var wishlistButtonAdded = Array.prototype.some.call(mutations, function(mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function(node) {
        return node.nodeType === 1 && (
          node.classList.contains('iwish-float-icon') ||
          node.querySelector('.iwish-float-icon')
        );
      });
    });

    if (wishlistButtonAdded && bindWishlistButton()) {
      observer.disconnect();
    }
  });

  wishlistObserver.observe(document.body, { childList: true, subtree: true });
})();


/* Task 41076757: Leaving Soon color groups (rev. 2026-09-17: label "Colors"; hide fully sold-out colors) */
(function() {
  'use strict';

  var productGroups = {
    '/products/speedex-23': ['Black/Red/Grey'],
    '/products/speedex-ultra': ['Lime/Black', 'Black/White/Red'],
    '/products/adidas-box-hog-4-boxing-shoes': [
      'White/Black',
      'Triple White',
      'Grey Three/ Cloud White/ Core Black',
      'Lucid Blue/ Cloud White/ Pre-loved Blue'
    ]
  };

  function normalizedPath(pathname) {
    return pathname.replace(/\/$/, '');
  }

  function isLeavingSoonEntry() {
    var params = new URLSearchParams(window.location.search);
    return params.get('from') === 'leaving-soon' ||
      document.referrer.indexOf('/collections/leaving-soon') !== -1;
  }

  // Rev: colors whose every size is out of stock are hidden from the PDP.
  function soldOutColorValues() {
    var el = document.querySelector('[data-product-json]');
    if (!el) { return []; }
    var product;
    try { product = JSON.parse(el.textContent); } catch (error) { return []; }
    if (!product || !product.options || !product.variants) { return []; }

    var colorIndex = -1;
    product.options.forEach(function(opt, index) {
      var name = (typeof opt === 'string') ? opt : (opt && opt.name);
      if (name && name.toLowerCase().indexOf('color') !== -1) { colorIndex = index; }
    });
    if (colorIndex === -1) { return []; }

    var optionKey = 'option' + (colorIndex + 1);
    var available = {};
    product.variants.forEach(function(variant) {
      var value = variant[optionKey];
      if (available[value] === undefined) { available[value] = false; }
      if (variant.available) { available[value] = true; }
    });
    return Object.keys(available).filter(function(value) { return available[value] === false; });
  }

  function createGroup(kind, title, subtitle) {
    var group = document.createElement('div');
    var heading = document.createElement('div');
    var titleElement = document.createElement('span');
    var swatches = document.createElement('div');
    var headingId = 'color-group-' + kind + '-' + Math.random().toString(36).slice(2, 9);

    group.className = 'ls-option-group ls-option-group--' + kind;
    group.setAttribute('role', 'group');
    group.setAttribute('aria-labelledby', headingId);

    heading.className = 'ls-option-group__header';
    titleElement.className = 'ls-option-group__title';
    titleElement.id = headingId;
    titleElement.textContent = title;
    heading.appendChild(titleElement);

    if (subtitle) {
      var subtitleElement = document.createElement('span');
      subtitleElement.className = 'ls-option-group__subtitle';
      subtitleElement.textContent = subtitle;
      heading.appendChild(subtitleElement);
    }

    swatches.className = 'radio__inputs radio__inputs--swatch ls-option-group__swatches';
    group.appendChild(heading);
    group.appendChild(swatches);

    return { element: group, swatches: swatches };
  }

  function groupColorOptions(wrapper, leavingSoonValues, leavingSoonFirst, soldOut) {
    if (!wrapper || wrapper.hasAttribute('data-leaving-soon-groups')) {
      return;
    }

    var originalSwatches = wrapper.querySelector('.radio__inputs');
    if (!originalSwatches) {
      return;
    }

    var optionNodes = Array.prototype.filter.call(originalSwatches.children, function(node) {
      return node.querySelector && node.querySelector('input[type="radio"]');
    });

    // Rev: remove colors that are completely out of inventory across all sizes.
    optionNodes = optionNodes.filter(function(node) {
      var input = node.querySelector('input[type="radio"]');
      if (soldOut.indexOf(input.value) !== -1) {
        node.parentNode.removeChild(node);
        return false;
      }
      return true;
    });

    var leavingSoonNodes = [];
    var currentNodes = [];

    optionNodes.forEach(function(node) {
      var input = node.querySelector('input[type="radio"]');
      if (leavingSoonValues.indexOf(input.value) !== -1) {
        leavingSoonNodes.push(node);
      } else {
        currentNodes.push(node);
      }
    });

    if (!leavingSoonNodes.length || !currentNodes.length) {
      wrapper.setAttribute('data-leaving-soon-groups', 'true');
      return;
    }

    var root = document.createElement('div');
    var currentGroup = createGroup('current', 'Colors');
    var leavingGroup = createGroup('leaving-soon', 'Leaving Soon', 'Limited availability');
    var preferredGroup = leavingSoonFirst ? leavingGroup : currentGroup;

    root.className = 'ls-option-groups';
    root.setAttribute('data-entry-order', leavingSoonFirst ? 'leaving-soon-first' : 'current-first');

    currentNodes.forEach(function(node) {
      currentGroup.swatches.appendChild(node);
    });
    leavingSoonNodes.forEach(function(node) {
      leavingGroup.swatches.appendChild(node);
    });

    if (leavingSoonFirst) {
      root.appendChild(leavingGroup.element);
      root.appendChild(currentGroup.element);
    } else {
      root.appendChild(currentGroup.element);
      root.appendChild(leavingGroup.element);
    }

    originalSwatches.parentNode.replaceChild(root, originalSwatches);
    wrapper.setAttribute('data-leaving-soon-groups', 'true');

    var params = new URLSearchParams(window.location.search);
    if (!params.has('variant')) {
      var checked = root.querySelector('input[type="radio"]:checked');
      var checkedGroup = checked && checked.closest('.ls-option-group');
      if (checkedGroup !== preferredGroup.element) {
        var preferredInput = preferredGroup.swatches.querySelector('input[type="radio"]');
        if (preferredInput) {
          preferredInput.click();
        }
      }
    }
  }

  function refreshProductGroups(root) {
    var path = normalizedPath(window.location.pathname);
    var leavingSoonValues = productGroups[path];
    if (!leavingSoonValues || !root.querySelectorAll) {
      return;
    }

    var soldOut = soldOutColorValues();

    Array.prototype.forEach.call(
      root.querySelectorAll('.selector-wrapper--color'),
      function(wrapper) {
        groupColorOptions(wrapper, leavingSoonValues, isLeavingSoonEntry(), soldOut);
      }
    );
  }

  function addLeavingSoonContext(root) {
    if (normalizedPath(window.location.pathname) !== '/collections/leaving-soon' || !root.querySelectorAll) {
      return;
    }

    Array.prototype.forEach.call(root.querySelectorAll('a[href*="/products/"]'), function(link) {
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (!productGroups[normalizedPath(url.pathname)]) {
        return;
      }

      url.searchParams.set('from', 'leaving-soon');
      link.href = url.pathname + url.search + url.hash;
    });
  }

  function addStyles() {
    if (document.getElementById('leaving-soon-color-group-styles')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'leaving-soon-color-group-styles';
    style.textContent = [
      '.ls-option-groups{display:flex;flex-direction:column;gap:14px;width:100%;}',
      '.ls-option-group{border:1px solid #d6d6d6;padding:14px 16px 16px;background:#fff;}',
      '.ls-option-group--leaving-soon{border-left:4px solid #111;background:#f6f6f6;}',
      '.ls-option-group__header{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-bottom:12px;}',
      '.ls-option-group__title{font-size:14px;font-weight:700;letter-spacing:.02em;}',
      '.ls-option-group__subtitle{font-size:12px;color:#555;}',
      '.ls-option-group__swatches{margin:0;}',
      '@media(max-width:767px){.ls-option-group{padding:12px;}.ls-option-group__header{align-items:flex-start;flex-direction:column;gap:2px;}.ls-option-group__swatches{gap:8px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function refresh(root) {
    addStyles();
    refreshProductGroups(root);
    addLeavingSoonContext(root);
  }

  refresh(document);
  document.addEventListener('shopify:section:load', function(event) {
    refresh(event.target);
  });
})(window);


;(function(window){"use strict";
  // ACS Leaving Soon - swatch callouts (New/Sale) + Unavailable swap.
  // Added 2026-09-17 per Kyle Tapper (task 41076757). Additive to the color-group module.
  // Rev. 2026-09-18: Notify Me -> Unavailable swap rebuilt against the real Klaviyo
  // back-in-stock markup Kyle supplied (#klaviyo-bis-button-container /
  // [data-a11y-identifier^="bis-button-"]). Klaviyo injects that button at runtime after
  // the theme's own events fire and re-renders it on variant change, so the swap now runs
  // from a MutationObserver and is fully reversible when a non-Leaving-Soon or in-stock
  // variant is selected. The button's go* classes are hashed per build and are never targeted.
  // Callout hierarchy per color: 1) New if a variant of that color was created in the
  // last 3 months; 2) else Sale if that color has a compare-at price. One callout per color.
  // NOTE: variant created-at is not exposed in the storefront product JSON, so "New" colors
  // are baked from the Admin API. As of 2026-09-17 no color in these products qualifies as
  // New (newest variant created 2026-02-11), so every map below is empty and colors with a
  // compare-at price fall through to "Sale". Refresh this map when genuinely new colors ship.
  var NEW_COLORS = {
    "/products/speedex-23": [],
    "/products/speedex-ultra": [],
    "/products/adidas-box-hog-4-boxing-shoes": []
  };
  // Leaving Soon (discontinued) colors per product, mirrors the color-group module.
  var LEAVING_SOON = {
    "/products/speedex-23": ["Black/Red/Grey"],
    "/products/speedex-ultra": ["Lime/Black", "Black/White/Red"],
    "/products/adidas-box-hog-4-boxing-shoes": ["White/Black", "Triple White", "Grey Three/ Cloud White/ Core Black", "Lucid Blue/ Cloud White/ Pre-loved Blue"]
  };

  function normalizedPath(pathname){ return pathname.replace(/\/$/, ""); }

  function productJson(){
    var el = document.querySelector("[data-product-json]");
    if(!el) return null;
    try { return JSON.parse(el.textContent); } catch(e){ return null; }
  }

  function colorOptionIndex(product){
    if(!product || !product.options) return -1;
    var idx = -1;
    product.options.forEach(function(opt, i){
      var name = typeof opt === "string" ? opt : (opt && opt.name);
      if(name && name.toLowerCase().indexOf("color") !== -1) idx = i;
    });
    return idx;
  }

  // Colors that have a compare-at price greater than the selling price (on sale).
  function saleColorValues(product){
    var out = {};
    if(!product || !product.variants) return out;
    var cIdx = colorOptionIndex(product);
    if(cIdx === -1) return out;
    var key = "option" + (cIdx + 1);
    product.variants.forEach(function(v){
      var color = v[key];
      if(color == null) return;
      var price = Number(v.price) || 0;
      var cap = Number(v.compare_at_price) || 0;
      if(cap > price) out[color] = true;
    });
    return out;
  }

  function calloutFor(color, path, saleColors){
    var newList = NEW_COLORS[path] || [];
    if(newList.indexOf(color) !== -1) return "new";
    if(saleColors[color]) return "sale";
    return null;
  }

  function decorateSwatch(node, path, saleColors){
    if(!node || node.hasAttribute("data-ls-callout-done")) return;
    var input = node.querySelector('input[type="radio"]');
    if(!input) return;
    node.setAttribute("data-ls-callout-done", "true");
    var kind = calloutFor(input.value, path, saleColors);
    if(!kind) return;
    var badge = document.createElement("span");
    badge.className = "ls-callout ls-callout--" + kind;
    badge.textContent = kind === "new" ? "New" : "Sale";
    badge.setAttribute("aria-hidden", "false");
    node.appendChild(badge);
  }

  function decorateCallouts(root){
    var path = normalizedPath(window.location.pathname);
    if(!NEW_COLORS.hasOwnProperty(path)) return; // scope to the three managed products
    if(!root || !root.querySelectorAll) return;
    var product = productJson();
    var saleColors = saleColorValues(product);
    Array.prototype.forEach.call(root.querySelectorAll(".selector-wrapper--color .variant__swatch__button"), function(node){
      decorateSwatch(node, path, saleColors);
    });
  }

  // ---- Notify Me -> Unavailable, only for Leaving Soon colors that are out of stock ----
  // Klaviyo injects a back-in-stock button at runtime (markup confirmed by Kyle 2026-09-18):
  //   <div id="klaviyo-bis-button-container">
  //     <div data-a11y-identifier="bis-button-######" class="needsclick go… kl-private-reset-css-…">
  //       <button type="button" data-a11y-identifier="bis-button-######" class="needsclick go… …">NOTIFY ME</button>
  //     </div>
  //   </div>
  // The go* classes are per-build hashes; we anchor on the stable id, the stable
  // data-a11y-identifier prefix, and the visible "notify" text.
  function selectedColorValue(){
    var checked = document.querySelector('.selector-wrapper--color input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  // This theme does NOT render a hidden input[name="id"] in the product form, so the
  // selected variant must be resolved from the checked option inputs. The theme names
  // every option input options[<OptionName>] (radio for color/short size; a hidden
  // input for the popout used by long size values). Match product.options in order
  // against those selected values, then read that exact variant's `available` field.
  function optionNames(product){
    if(!product || !product.options) return [];
    return product.options.map(function(o){
      return typeof o === "string" ? o : (o && o.name);
    }).filter(Boolean);
  }

  function selectedOptionValue(name){
    // Inputs bind to the form by form="..." and may live outside it, so query the document.
    var checked = document.querySelector('input[name="options[' + name + ']"]:checked');
    if(checked) return checked.value;
    var any = document.querySelector('input[name="options[' + name + ']"]');
    return any ? any.value : null; // hidden popout input carries the selected value
  }

  function selectedVariant(product){
    var names = optionNames(product);
    if(!names.length || !product || !product.variants) return null;
    var selected = names.map(selectedOptionValue);
    if(selected.indexOf(null) !== -1) return null; // an option is not resolvable yet
    return product.variants.filter(function(v){
      for(var i = 0; i < selected.length; i++){
        if(String(v["option" + (i + 1)]) !== String(selected[i])) return false;
      }
      return true;
    })[0] || null;
  }

  function currentVariantUnavailable(){
    var v = selectedVariant(productJson());
    return v ? !v.available : false;
  }

  function isLeavingSoonColor(){
    var path = normalizedPath(window.location.pathname);
    var list = LEAVING_SOON[path];
    if(!list) return false;
    var color = selectedColorValue();
    return color != null && list.indexOf(color) !== -1;
  }

  // Return the actual Klaviyo back-in-stock BUTTON(s) in the DOM. Keep Klaviyo's own
  // container mounted so its mount/unmount lifecycle is never disturbed; we relabel the
  // button in place instead of hiding the container. Anchor on the stable
  // data-a11y-identifier prefix, then fall back to a button inside the stable container.
  // Never target the hashed go* classes.
  function notifyButtons(scope){
    var found = [];
    function add(btn){ if(btn && btn.tagName === "BUTTON" && found.indexOf(btn) === -1) found.push(btn); }
    // 1) The button itself, by its stable data-a11y-identifier prefix.
    Array.prototype.forEach.call(scope.querySelectorAll('button[data-a11y-identifier^="bis-button-"]'), add);
    // 2) Container fallback: the stable Klaviyo container id, then its button.
    Array.prototype.forEach.call(scope.querySelectorAll('#klaviyo-bis-button-container, [id^="klaviyo-bis-button-container"]'), function(c){
      var b = c.querySelector('button[data-a11y-identifier^="bis-button-"]') || c.querySelector('button');
      if(b) add(b);
    });
    return found;
  }

  // Relabel/disable the Notify Me button in place as "Unavailable". Original text,
  // disabled and aria-disabled state are saved once so a later restore is exact.
  function setUnavailable(btn){
    if(btn.getAttribute("data-ls-swapped") !== "true"){
      btn.setAttribute("data-ls-orig-text", btn.textContent);
      btn.setAttribute("data-ls-orig-disabled", btn.disabled ? "true" : "false");
      btn.setAttribute("data-ls-orig-aria", btn.hasAttribute("aria-disabled") ? ("v:" + btn.getAttribute("aria-disabled")) : "absent");
      btn.setAttribute("data-ls-swapped", "true");
    }
    // Enforce each pass (only mutating when needed) so a Klaviyo re-render is corrected
    // without churning the DOM into an observer loop.
    if(btn.textContent !== "Unavailable") btn.textContent = "Unavailable";
    if(!btn.disabled) btn.disabled = true;
    if(btn.getAttribute("aria-disabled") !== "true") btn.setAttribute("aria-disabled", "true");
    if(!btn.classList.contains("ls-bis-unavailable")) btn.classList.add("ls-bis-unavailable");
  }

  function restoreButton(btn){
    if(btn.getAttribute("data-ls-swapped") !== "true") return;
    if(btn.hasAttribute("data-ls-orig-text")) btn.textContent = btn.getAttribute("data-ls-orig-text");
    btn.disabled = btn.getAttribute("data-ls-orig-disabled") === "true";
    var oa = btn.getAttribute("data-ls-orig-aria");
    if(oa && oa.indexOf("v:") === 0) btn.setAttribute("aria-disabled", oa.slice(2));
    else btn.removeAttribute("aria-disabled");
    btn.classList.remove("ls-bis-unavailable");
    btn.removeAttribute("data-ls-swapped");
    btn.removeAttribute("data-ls-orig-text");
    btn.removeAttribute("data-ls-orig-disabled");
    btn.removeAttribute("data-ls-orig-aria");
  }

  function relabelNotifyButton(){
    var path = normalizedPath(window.location.pathname);
    if(!LEAVING_SOON.hasOwnProperty(path)) return;
    // Swap only when the selected color is Leaving Soon AND the exact selected
    // size variant is unavailable. Otherwise restore the button to Notify Me.
    var swap = isLeavingSoonColor() && currentVariantUnavailable();
    // Always evaluate the whole document so a button swapped for a prior Leaving Soon
    // selection is restored when the shopper switches to a current color or in-stock size.
    notifyButtons(document).forEach(function(btn){
      if(swap) setUnavailable(btn); else restoreButton(btn);
    });
    // If we should swap but Klaviyo has not injected the button yet, the observer re-runs us.
  }

  function addStyles(){
    if(document.getElementById("ls-callout-styles")) return;
    var style = document.createElement("style");
    style.id = "ls-callout-styles";
    style.textContent = [
      ".ls-option-group__swatches .variant__swatch__button{display:inline-flex;flex-direction:column;align-items:center;gap:4px;}",
      ".ls-callout{display:block;font-size:10px;line-height:1.2;font-weight:700;letter-spacing:.04em;text-transform:uppercase;text-align:center;}",
      ".ls-callout--new{color:#0a7d2c;}",
      ".ls-callout--sale{color:#b3261e;}",
      "button.ls-bis-unavailable{background:#fff !important;color:#8a8a8a !important;border:1px solid #c9c9c9 !important;box-shadow:none !important;opacity:1 !important;cursor:not-allowed !important;width:100% !important;text-align:center !important;font-weight:700 !important;text-transform:uppercase !important;letter-spacing:.1em !important;}"
    ].join("");
    document.head.appendChild(style);
  }

  // Watch for the runtime-injected Klaviyo button (and any variant re-render) so the swap
  // applies after Klaviyo mounts, not only on the theme's own synchronous events.
  var observer = null;
  function startObserver(){
    if(observer || typeof MutationObserver === "undefined") return;
    var path = normalizedPath(window.location.pathname);
    if(!LEAVING_SOON.hasOwnProperty(path)) return;
    var target = document.querySelector('form[data-product-form]') ||
                 document.querySelector('.product__info-wrapper, .product-form, main') ||
                 document.body;
    if(!target) return;
    var scheduled = false;
    observer = new MutationObserver(function(){
      if(scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function(){
        scheduled = false;
        relabelNotifyButton(document);
      });
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function run(root){
    addStyles();
    decorateCallouts(root || document);
    relabelNotifyButton(root || document);
    startObserver();
  }

  run(document);
  document.addEventListener("shopify:section:load", function(e){ run(e.target); });
  document.addEventListener("theme:variant:change", function(){ run(document); });
  document.addEventListener("change", function(e){
    if(e.target && e.target.matches && e.target.matches('input[type="radio"]')) run(document);
  }, true);
})(window);
